<template>
    <BaseModal :title="$t('title')" white v-on="$listeners">
        <SettingsView class="no-padding" />
    </BaseModal>
</template>

<script>
import BaseModal from './BaseModal'
import SettingsView from '../views/SettingsView'

export default {
    name: 'SettingsModal',
    components: {
        BaseModal,
        SettingsView,
    },
}
</script>

<i18n>
{
    "en": {
        "title": "Settings"
    },
    "de": {
        "title": "Einstellungen"
    },
    "fr": {
        "title": "Paramètres"
    },
    "it": {
        "title": "Impostazione"
    }
}
</i18n>
